import { render, staticRenderFns } from "./JournalsList.vue?vue&type=template&id=2b73c3b5&scoped=true&"
import script from "./JournalsList.vue?vue&type=script&lang=js&"
export * from "./JournalsList.vue?vue&type=script&lang=js&"
import style0 from "./JournalsList.vue?vue&type=style&index=0&id=2b73c3b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b73c3b5",
  null
  
)

export default component.exports